@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Kentucky</h2>

  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">UM Coverage:</h3>
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>

        <div class="axis-grid">
          <!-- Displaying minimum limit as readonly text -->
          @if (
            (baseRules?.["UM_SplitMinLimits_DropDown"] || "").includes("readonly") &&
            (reactiveForm.get('levelOneUM_Radio')?.value === 'Limits_LevelOneUM_Radio' ||
              reactiveForm.get('levelOneUM_Radio')?.value?.value === 'Limits_LevelOneUM_Radio')
          ) {
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label"> {{ controls[4].label }} </label>
                <div id="um_splitminlimits_25k_50k-pdffield-kentucky">{{ controls[4].data[0].name }}</div>
              </div>
            </div>
          }
          @if (
            (baseRules?.["UM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly") &&
            (reactiveForm.get('levelOneUM_Radio')?.value === 'Limits_LevelOneUM_Radio' ||
              reactiveForm.get('levelOneUM_Radio')?.value?.value === 'Limits_LevelOneUM_Radio')
          ) {
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label"> {{ controls[5].label }} </label>
                <div id="um_combinedsingleminlimit_60k-pdffield-kentucky">{{ controls[5].data[0].name }}</div>
              </div>
            </div>
          }
          <!-- Displaying limit as dropdown -->
          @for (control of controls | slice: 2 : 6; track $index) {
            @if (
              baseRules[control.baseRuleKey]?.includes("show") &&
              (reactiveForm.get('levelOneUM_Radio')?.value === 'Limits_LevelOneUM_Radio' ||
                reactiveForm.get('levelOneUM_Radio')?.value?.value === 'Limits_LevelOneUM_Radio')
            ) {
              <div class="axis-col-sm-6 axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                    >{{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <axis-dropdown
                    (onSelect)="changeOnSelection($event, control.formControlName)"
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select an option.</span
                      >
                    }
                  }
                </div>
              </div>
            }
          }
        </div>
      }
      @if (controls?.length >= 7) {
        <h3 class="axis-h5">UIM Coverage:</h3>
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[6].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[6].formControlName)?.touched &&
              reactiveForm.get(controls[6].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[6].formControlName }}">
            @for (control of controls[6].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[6].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[6].formControlName)?.touched) {
            @if (reactiveForm.get(controls[6].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      @if (controls?.length >= 8) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[7].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[7].formControlName)?.touched &&
              reactiveForm.get(controls[7].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[7].formControlName }}">
            @for (control of controls[7].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[7].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[7].formControlName)?.touched) {
            @if (reactiveForm.get(controls[7].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <div class="axis-grid">
        <!-- Displaying minimum limit as readonly text -->
        @if (
          (baseRules?.["UIM_SplitMinLimits_DropDown"] || "").includes("readonly") &&
          (reactiveForm.get('levelOneUIM_Radio')?.value === 'Limits_LevelOneUIM_Radio' ||
            reactiveForm.get('levelOneUIM_Radio')?.value?.value === 'Limits_LevelOneUIM_Radio')
        ) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[10].label }} </label>
              <div id="uim_splitminlimits_25k_50k-pdffield-kentucky">{{ controls[10].data[0].name }}</div>
            </div>
          </div>
        }
        @if (
          (baseRules?.["UIM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly") &&
          (reactiveForm.get('levelOneUIM_Radio')?.value === 'Limits_LevelOneUIM_Radio' ||
            reactiveForm.get('levelOneUIM_Radio')?.value?.value === 'Limits_LevelOneUIM_Radio')
        ) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[11].label }} </label>
              <div id="uim_combinedsingleminlimit_60k-pdffield-kentucky">{{ controls[11].data[0].name }}</div>
            </div>
          </div>
        }
        <!-- Displaying limit as  dropdown-->
        @for (control of controls | slice: 8; track $index) {
          @if (
            baseRules[control.baseRuleKey]?.includes("show") &&
            (reactiveForm.get('levelOneUIM_Radio')?.value === 'Limits_LevelOneUIM_Radio' ||
              reactiveForm.get('levelOneUIM_Radio')?.value?.value === 'Limits_LevelOneUIM_Radio')
          ) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  ></label
                >
                <axis-dropdown
                  (onSelect)="changeOnSelection($event, control.formControlName)"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
        <!-- Display message when both radio buttons are checked -->
        @if (bothRadioButtonsChecked) {
          <div
            class="axis-alert axis-alert-info"
            style="padding: 0.75rem"
          >
            <b>{{ textValues?.Same_Limit_Message }}</b>
          </div>
        }
      </div>
      <!-- Display Refer Text -->
      <P> {{ textValues?.Refer_Text }} </P>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Kentucky</h2>
  @if (baseRules?.Reject_LevelOneUMUIM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        <span [innerHTML]="textValues?.Reject_Text_UM_UIM"></span>
      </label>
    </div>
  }

  <div class="axis-grid">
    @if (baseRules?.UM_SplitMinLimits_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[4].label }} </label>
          <div>{{ controls[4].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.UM_CombinedSingleMinLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[5].label }} </label>
          <div>{{ controls[5].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.UIM_SplitMinLimits_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[10].label }} </label>
          <div>{{ controls[10].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.UIM_CombinedSingleMinLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[11].label }} </label>
          <div>{{ controls[11].data[0].name }}</div>
        </div>
      </div>
    }

    @if (baseRules?.UM_LiabilityLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls?.[12]?.label }} </label>
          <div>{{ controls?.[12]?.data?.[0]?.name }}</div>
        </div>
      </div>
    }

    @if (baseRules?.UIM_LiabilityLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls?.[13]?.label }} </label>
          <div>{{ controls?.[13]?.data?.[0]?.name }}</div>
        </div>
      </div>
    }
  </div>
}